import { auth, ADMIN_UID } from "../db/firebase.js";
import { onAuthStateChanged, signInWithEmailAndPassword } from "firebase/auth";

export let currentUserId = null;
export let isAdmin = false;

export function setupAuth(loadCases, loadReviews) {
  onAuthStateChanged(auth, (user) => {
    if (user) {
      currentUserId = user.uid;
      // console.log("Ваш User ID:", currentUserId);

      isAdmin = currentUserId === ADMIN_UID;

      if (isAdmin) {
        // console.log("Статус Администратора: АКТИВИРОВАН");
        document
          .querySelectorAll(".admin-only")
          .forEach((el) => el.classList.remove("hidden"));
      } else {
        // console.log("Статус Администратора: неактивен.");
        document
          .querySelectorAll(".admin-only")
          .forEach((el) => el.classList.add("hidden"));
      }
    } else {
      currentUserId = null;
      isAdmin = false;
      document
        .querySelectorAll(".admin-only")
        .forEach((el) => el.classList.add("hidden"));
      // console.log("Пользователь не вошел в систему.");
    }

    loadCases();
    loadReviews();
  });
}

export async function loginAdmin(email, password) {
  const userCredential = await signInWithEmailAndPassword(
    auth,
    email,
    password,
  );
  const uid = userCredential.user.uid;
  if (uid !== ADMIN_UID) {
    await auth.signOut();
    throw new Error("Not an admin");
  }
  return uid;
}
